import { createSelector } from "reselect";

const getUpcomingSelector = state => {
  return state.upcoming.moviesUpcoming;
};

export const getUpcoming = createSelector(
  getUpcomingSelector,
  moviesUpcoming => {
    return moviesUpcoming;
  }
);
